import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "the-footage-tab",
  courseId: "reports-from-audio",
  order: 5,
  title: "The Footage tab",
  summary:
    "Play the video with event markers, jump to any point of interest, and attach a still to the report.",
  learn: [
    "Read the marker bar and the points-of-interest list",
    "Seek to an event and review the still",
    "Attach a frame to the narrative",
  ],
  minutes: 3,
  releasedAt: "2026-09-24T00:00:00.000Z",
  sceneId: "the-footage-tab",
  tourId: "the-footage-tab",
  gate: "video",
  body: [
    {
      type: "paragraph",
      text: "When a case has analyzed footage, its **Transcription** tab is named **Footage** and opens on the video view. A **Footage** / **Transcription** switch above the view takes you to the editable transcript. Use the tab to find the moment you need to cite.",
    },
    {
      type: "steps",
      items: [
        "Open the **Footage** tab. The player shows the video with a marker bar on its seek bar.",
        "Hover a dot on the marker bar to see the still and description. Click the dot to seek there.",
        "Use the previous and next buttons in the player to step through points of interest.",
        "Use the **What happened** list on the right. It follows the playhead, and you can filter it by kind, for example every property item or every vehicle.",
        "Read the transcript under the player, which stays synced to what you are watching.",
        "At the top of the right-hand rail, read **What the footage shows** (the summary) and **Footage check** (the findings from comparing the draft with the video).",
        "In the strip along the bottom (**Attach a still to the report**), click a still to attach it to the exported report. Click it again to remove it.",
      ],
    },
    {
      type: "paragraph",
      text: "On the marker bar, dots are colored by event kind, clustered where events are dense, and idle stretches are dimmed.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Stills are served on demand from the extracted frames, so attaching one does not re-process the video. Attach the frame that supports a disputed detail, not every frame. Attached stills are listed in the rail.",
    },
    {
      type: "callout",
      tone: "note",
      text: "Footage minutes are metered against your department's footage pool, separately from the Investigations pool. The admin sees usage on the dashboard.",
    },
    {
      type: "paragraph",
      text: "\"Verify vs enrich\" explains where the \"Footage check\" findings come from. \"Investigation footage\" covers the same video view in an investigation.",
    },
  ],
  related: ["verify-vs-enrich", "footage-in-investigations"],
};

export default lesson;
